var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.development)?_c('span',{staticClass:"wrapper",on:{"click":function($event){return _vm.openSettings()}}},[_c('i',{staticClass:"fal fa-cog"})]):_vm._e(),_c('development-settings-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }